export default __webpack_public_path__ + "static/media/TapPay_logo.c8bfb38b.png";